import type { components } from '@/generated/contracts/api-v1';
import { fieldMap, type FieldSpec, type LegacyRow } from './fieldMap';

// org_members table; OrgReadService.ToDto (lureo-backend Data/Api/V1/Orgs/OrgReadService.cs)
export type OrgMemberDto = components['schemas']['OrgMemberDto'];

// listOrgMembers returns a colleague's private fields as null (preferences, persona, commercial
// intent, discovery source, utm, 2FA, watermark); a member sees their own, staff see everyone's
const spec = {
  // The membership's numeric id, which other tables reference as org_member_id
  id: 'id',
  orgUniqueId: 'org_instance_id',
  userUniqueId: 'user_id',
  memberType: 'member_type',
  // The entity holds the preferences as an object; v1 unwraps a JSON string holding one, and reads anything else as null
  memberPreferences: { legacy: 'member_preferences', as: 'json' },
  allTutorialLessonsComplete: 'member_all_tutorial_lessons_complete',
  fullName: 'full_name',
  avatarUrl: 'avatar_url',
  twoFactorAuthentication: 'two_factor_authentication',
  displayImmersalWatermark: 'display_immersal_watermark',
  trackOneMember: 'track_one_member',
  trackTwoMember: 'track_two_member',
  persona: 'persona',
  commercialIntent: 'commercial_intent',
  discoverySource: 'discovery_source',
  utmSource: 'utm_source',
  utmCampaign: 'utm_campaign',
  createdAt: 'created_at',
} as const satisfies FieldSpec<OrgMemberDto>;

const map = fieldMap<OrgMemberDto, typeof spec>('Org member', spec);

export type LegacyOrgMember = LegacyRow<typeof spec, OrgMemberDto>;

/** updateMyOrgMember accepts these. */
export const MY_ORG_MEMBER_PATCH_FIELDS = [
  'fullName', 'avatarUrl', 'memberPreferences', 'displayImmersalWatermark', 'persona',
  'commercialIntent', 'discoverySource',
] as const;

export const orgMemberToLegacy = (dto: OrgMemberDto): LegacyOrgMember => map.toLegacy(dto);

/** updateMyOrgMember body from a legacy partial update of the caller's own membership. */
export const myOrgMemberPatchBody = (changes: Partial<LegacyOrgMember>) => map.toBody(changes, MY_ORG_MEMBER_PATCH_FIELDS);
